import { defineMessages } from 'react-intl'

const scope = `procurify.modules.purchasing.features.list-po-pdf-custom-field-display.views.po-pdf-custom-field-toggle-table`

export default defineMessages({
  columnCustomField: {
    id: `${scope}.columnCustomField`,
    defaultMessage: 'Custom field',
  },
  columnDisplayInPdf: {
    id: `${scope}.columnDisplayInPdf`,
    defaultMessage: 'Display in PDF',
  },
  toggleAriaLabel: {
    id: `${scope}.toggleAriaLabel`,
    defaultMessage: 'Toggle display in PDF for {name}',
  },
  emptyStateText: {
    id: `${scope}.emptyStateText`,
    defaultMessage: 'There are no custom fields',
  },
})
